import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import waitingQueue from './waitingQueue'
import room from './room'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    waitingQueue: waitingQueue,
    room: room
  },
  state: {
    isStandalone: false,
    userId: null,
    status: 'offline',
    signedIn: false,
    onlineUserCount: 0
  },
  mutations: {
    setIsStandalone (state, { isStandalone }) {
      state.isStandalone = isStandalone
    },
    setUserId (state, { userId }) {
      state.userId = userId
    },
    setStatus (state, { status }) {
      state.status = status
    },
    setSignedIn (state, { signedIn }) {
      state.signedIn = signedIn
    },
    setOnlineUserCount (state, { onlineUserCount }) {
      state.onlineUserCount = onlineUserCount
    }
  },
  actions: {
    async signUp () {
      await firebase.auth().signInAnonymously()
    },

    async logout ({ dispatch }) {
      await dispatch('pause')
      await firebase.auth().signOut()
    },

    async next ({ dispatch, state }) {
      if (!state.signedIn) {
        global.DEBUG && console.log('not signed in')
        return
      }

      let leaveRoomAsync = null
      if (state.room.roomId !== null) {
        leaveRoomAsync = dispatch('room/leave', { isInitiator: true })
      }

      await Promise.all([
        leaveRoomAsync,
        dispatch('waitingQueue/start', {
          userId: state.userId,
          onPeerFound: ({ remoteId }) => {
            global.DEBUG && console.log(`peer found: ${remoteId}`)
            dispatch('room/create', {
              localId: state.userId,
              remoteId: remoteId,
              onRoomTerminatedByPeer: () => {
                dispatch('next')
              }
            })
          }
        })
      ])
    },

    async handleInvitation ({ dispatch, state }, invitation) {
      if (!state.signedIn) {
        global.DEBUG && console.log('not signed in')
        return
      }
      await Promise.all([
        dispatch('waitingQueue/stop'),
        dispatch('room/join', {
          localId: state.userId,
          invitation: invitation,
          onRoomTerminatedByPeer: () => {
            dispatch('next')
          }
        })
      ])
    },

    async pause ({ dispatch, state }) {
      if (!state.signedIn) {
        global.DEBUG && console.log('not signed in')
        return
      }

      if (state.waitingQueue.isWaiting) {
        await dispatch('waitingQueue/stop')
      }

      if (state.room.roomId !== null) {
        await dispatch('room/leave', { isInitiator: true })
      }
    }
  },
  getters: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js